import { Alert, ConfigProvider } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import BannerAlertMessage, { BANNER_ALERT_COMPACT_CLASS } from "./BannerAlertMessage";
import { useUser } from "../../contexts/UserContext/UserContext";
import isBillingEnabled from "../../helpers/billing";

const TrialExpireAlert = () => {
    const { t } = useTranslation("banner");
    const [showAlert, setShowAlert] = useState(false);
    const history = useHistory();

    const { myCompanyData, state } = useUser();

    useEffect(() => {
        // Show alert when user is authenticated and trial is expired
        if (state.isAuthenticated && myCompanyData && isBillingEnabled(myCompanyData)) {
            setShowAlert(myCompanyData?.isTrialAccount === true && myCompanyData?.trialExpired === true);
        } else {
            setShowAlert(false);
        }
    }, [myCompanyData, state.isAuthenticated]);

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const handleNavigateToPayment = () => {
        history.push("/settings?menu=billing");
    };

    if (!showAlert) {
        return null;
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#ff9800",
                    colorInfoBg: "#ff9800",
                    colorText: "#000000",
                    colorIcon: "#000000",
                },
                components: {
                    Alert: {
                        // defaultPadding: 0,
                    },
                },
            }}>
            <Alert
                className={BANNER_ALERT_COMPACT_CLASS}
                message={
                    <BannerAlertMessage
                        actionLabel={t("trialAlert.subscribe", "Subscribe Now")}
                        onAction={handleNavigateToPayment}>
                        {t("trialAlert.message", "Your trial period has expired.")}{" "}
                        <span className="font-semibold">
                            {t("trialAlert.action", "Please subscribe to a plan")}
                        </span>{" "}
                        {t("trialAlert.continuation", "to continue using our services.")}
                    </BannerAlertMessage>
                }
                banner
                type="info"
                closable
                afterClose={handleCloseAlert}
                showIcon={false}
            />
        </ConfigProvider>
    );
};

export default TrialExpireAlert;
